<div class="dashboard-container container-fluid">
  <div class="row g-4 justify-content-center">
    <div
      class="col-12 col-sm-6 col-md-6 col-lg-6"
      *ngFor="let item of menuItems"
    >
      <div class="card dashboard-card" [routerLink]="item.ruta">
        <div class="card-body text-center">
          <fa-icon [icon]="item.icono" size="3x"></fa-icon>
          <h5 class="card-title mt-2">{{ item.nombre }}</h5>
        </div>
      </div>
    </div>
  </div>
</div>
